export const orgHasSetting = (orgData, setting) => {
  return orgData?.settings?.indexOf(setting) > -1 || false;
};

export const orgHasLicense = (orgData, licenseName) => {
  return orgData?.licenses?.some(license => license.skus?.some(sku => sku.name === licenseName)) || false;
};
